module.exports = __webpack_public_path__ + "static/media/KMH_5156.291c4074.jpg";